var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditable)?_c('div',{staticClass:"user-field"},[(_vm.fieldKey === 'birthday')?_c('generic-date-picker',{attrs:{"component":_vm.fieldComponent,"value":_vm.fieldValue},on:{"input":_vm.emitValue}}):(_vm.fieldKey === 'profile_picture')?_c('change-profile-image',{attrs:{"size":120}}):(_vm.fieldKey === 'gender')?_c('generic-radio-group',{attrs:{"options":_vm.gendersList,"component":{
      ..._vm.fieldComponent,
      ...{
        props: {
          radioGroup: {
            row: true
          }
        }
      }
    },"value":_vm.fieldValue,"horizontal":true},on:{"input":_vm.emitValue}}):(_vm.fieldKey === 'country')?_c('country-field',{staticClass:"my-3",attrs:{"field":_vm.fieldComponent,"custom-props":_vm.field.props,"value":_vm.fieldValue},on:{"input":_vm.emitValue}}):_c('generic-input',{attrs:{"component":_vm.fieldComponent,"value":_vm.fieldValue},on:{"input":_vm.emitValue}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }